"use strict";

import _newArrowCheck from "@babel/runtime/helpers/newArrowCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.bind.js";
import jQuery from "jquery";
import select2 from "select2";
// Object.assign(window, { $: jQuery, jQuery });

// console.log(jQuery.fn);

// LAZY LOAD
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.lazyClass = "lazy";

// LAZY LOAD BACKGROUND IMAGE
document.addEventListener("lazybeforeunveil", function (e) {
  var bg = e.target.getAttribute("data-bg");
  if (bg) {
    e.target.style.backgroundImage = "url(" + bg + ")";
  }
});

// READ MORE
require("readmore-js");
require("picturefill");

// MAGNIFIC POPUP
require("magnific-popup");
import Pikaday from "pikaday";
import Moment from "moment";

// JS COOKIE
import Cookies from "js-cookie";
import { throttle, debounce } from "throttle-debounce";
import Swiper from "swiper";
require("./vendor/jquery.debouncedresize.js");
require("./vendor/resize-iframe.js");
require("jquery-countdown");
require("tooltipster");

// SCROLLTO
jQuery.fn.extend({
  scrollTo: function scrollTo(speed) {
    var targetOffset = jQuery(this).offset().top - 100;
    jQuery("html,body").animate({
      scrollTop: targetOffset
    }, speed);
    return this;
  }
});

// DETECT TOUCH DEVICE
var is_touch_device = function is_touch_device() {
  return "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};
is_touch_device() ? jQuery("html").addClass("touch") : jQuery("html").addClass("no-touch");

// TOUCH INPUT - REMOVE AUTOCORRECT, SPELLCHECK,...
var removeAutoCheckInFormBlock = function removeAutoCheckInFormBlock() {
  jQuery.each(["input", "textarea"], function (index, value) {
    if (jQuery(value).length) {
      jQuery(value).attr({
        autocapitalize: "off",
        autocorrect: "off",
        spellcheck: "false"
      });
    }
  });
};

// ADD OUTLINE ON KEYBOARD EVENTS ONLY
var styleFocusOnKeyboardEvents = function styleFocusOnKeyboardEvents() {
  var container = document.querySelector("body");
  document.addEventListener("keyup", function (event) {
    if (container.contains(event.target)) {
      container.classList.add("has-keyboard-focus");
    } else {
      container.classList.remove("has-keyboard-focus");
    }
  });
  document.addEventListener("mousedown", function (event) {
    if (container.contains(event.target)) {
      container.classList.remove("has-keyboard-focus");
    }
  });
};

// RESPONSIVE NAV SLIDE
var responsiveNav = function responsiveNav() {
  var $mobileNav = jQuery(".mobile-nav"),
    $mobileContainer = jQuery(".mobile-container"),
    $header = jQuery(".header");
  if (!jQuery(".mobile-nav").find(".main-nav__list").length) {
    $header.find(".block-search").clone().appendTo($mobileContainer);
    $mobileContainer.find("#s, #searchform").removeAttr("id").find("input").attr("id", "search-mobile");
    $mobileContainer.find("label").attr({
      id: "search-label-mobile",
      "for": "search-mobile"
    });
    $mobileContainer.find(".searchform").removeAttr("role");
  }
  if (window.matchMedia("(min-width: 992px)").matches) {
    jQuery(".mobile-container").insertBefore(jQuery(".header-top"));
  }
  var $mobileNav = jQuery(".mobile-nav"),
    $body = jQuery("body"),
    $headerZindex = jQuery(".header").css("z-index"),
    $headerCurrentlyZindex = jQuery(".header-currently").css("z-index");
  jQuery(document).on("click", ".bt-menu, .block-overlay", function (event) {
    if ($body.hasClass("menu-open")) {
      $mobileNav.attr("aria-hidden", "true");
      $body.removeClass("menu-open");
      jQuery(this).attr({
        "aria-expanded": "false",
        "aria-pressed": "false"
      });
      jQuery(".header").css("z-index", $headerZindex);
      jQuery(".header-currently").css("z-index", $headerCurrentlyZindex);
    } else {
      $mobileNav.attr("aria-hidden", "false");
      $body.addClass("menu-open");
      jQuery(this).attr({
        "aria-expanded": "true",
        "aria-pressed": "true"
      });
      jQuery(".header").css("z-index", "25");
      jQuery(".header-currently").css("z-index", "15");
    }
    event.preventDefault();
  });
};

// MAIN NAV STICKY
var mainNavSticky = function mainNavSticky() {
  if (!jQuery(".page-classified").length) {
    if (!jQuery("#main-nav--sticky").find(".row--main-nav").length) {
      if (jQuery(".page-single-article").length) {
        if (jQuery(".entry-share__list").length) {
          jQuery(".header__identity").clone().appendTo(jQuery("#main-nav--sticky .container"));
          jQuery("#main-nav--sticky").find(".logo img").attr("src", jQuery("#main-nav--sticky").find(".logo img").attr("src").replace("logo-id", "icon-logo-id"));
          jQuery(".entry-title").clone().appendTo(jQuery("#main-nav--sticky .container"));
          jQuery(".entry-share__list").clone().appendTo(jQuery("#main-nav--sticky .container"));
        } else {
          jQuery(".header__main").clone().appendTo(jQuery("#main-nav--sticky .container"));
          jQuery("#main-nav--sticky").find(".logo img").attr("src", jQuery("#main-nav--sticky").find(".logo img").attr("src")).css({
            height: "auto",
            width: "384"
          });
        }
      } else {
        jQuery(".header__main").clone().appendTo(jQuery("#main-nav--sticky .container"));
      }
    }
    if (window.matchMedia("(min-width: 768px)").matches) {
      var topNavSticky = jQuery("#main-nav--sticky"),
        jQuerymenuTop = jQuery(".header").outerHeight(),
        didScroll;
      jQuery.stickyMenu = function () {
        var jQueryscrollHeight = jQuery(window).scrollTop(),
          $body = jQuery("body");
        if (jQueryscrollHeight >= jQuerymenuTop) {
          $body.addClass("nav--sticky--visible");
        } else {
          $body.removeClass("nav--sticky--visible");
        }
      };
      jQuery.stickyMenu();
      didScroll = false;
      jQuery(window).scroll(function () {
        didScroll = true;
      });
      setInterval(function () {
        if (didScroll) {
          didScroll = false;
          jQuery.stickyMenu();
        }
      }, 150);
    }
  }
};

// SHOW / HIDE SEARCH
var showHideSearch = function showHideSearch() {
  var $headerZindex = jQuery(".header").css("z-index"),
    $headerCurrentlyZindex = jQuery(".header-currently").css("z-index");
  if (window.matchMedia("(min-width: 992px)").matches) {
    // BLOCK SEARCH POSITION
    jQuery(".block-search").css("width", jQuery(".header__links").width() - 20);
    if (jQuery(".header__links-list").height() - jQuery(".header-item__search").height() != 0) {
      jQuery(".block-search").css("margin-top", jQuery(".header__links-list").height() - jQuery(".header-item__search").height() + 3);
    }
  }
  jQuery(document).on("click", ".bt-search, .bt-close-search", function (event) {
    jQuery("body").toggleClass("search-active");
    if (window.matchMedia("(min-width: 992px)").matches) {
      jQuery(".header").find(".block-search").slideToggle();
      if (jQuery("body").hasClass("search-active")) {
        jQuery("#s").focus();
        jQuery("#search-label").trigger("click");
        jQuery(".header-currently").css("z-index", "15");
      }
    } else {
      jQuery(".mobile-container").find(".block-search").slideToggle();
      if (jQuery("body").hasClass("search-active")) {
        jQuery("#search-mobile").focus();
        jQuery("#search-label-mobile").trigger("click");
      }
      jQuery(".header-currently").css("z-index", $headerCurrentlyZindex);
    }
    event.preventDefault();
  });
};

// PROMOTION SLIDER
var promotionSlider = function promotionSlider() {
  if (jQuery(".promotion-slider").length) {
    if (jQuery(".home").length) {
      var $block_promotion = jQuery(".block-promotion"),
        swiperDownloadSlider = new Swiper(".promotion-slider", {
          speed: 800,
          loop: true,
          slidesPerView: 4,
          slidesPerGroup: 4,
          paginationClickable: true,
          navigation: {
            nextEl: ".block-promotion .swiper-button-next",
            prevEl: ".block-promotion .swiper-button-prev"
          },
          spaceBetween: 20,
          a11y: true,
          prevSlideMessage: "Précédent",
          nextSlideMessage: "Suivant",
          paginationBulletMessage: "Accéder à la diapositive {{index}}",
          onInit: function onInit() {
            $block_promotion.find(".swiper-button-prev, .swiper-button-next").show();
          },
          breakpoints: {
            992: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              onInit: function onInit() {
                $block_promotion.find(".swiper-button-prev, .swiper-button-next").show();
              }
            },
            767: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              paginationClickable: true,
              pagination: {
                el: ".block-promotion .swiper-pagination"
              },
              onInit: function onInit() {
                $block_promotion.find(".swiper-pagination, .swiper-button-prev, .swiper-button-next").show();
              }
            }
          }
        });
    }
    jQuery(".promotion-slider").find(".swiper-wrapper").css("opacity", "1");
  }
};

// TABLE RESPONSIVE
var tableResponsive = function tableResponsive() {
  if (jQuery(".entry-content").length) {
    if (jQuery(".entry-content").find("table").length) {
      jQuery(".entry-content").find("table").each(function () {
        // ADD DIV AROUND EACH TABLE
        var tableResponsiveContainer = '<div class="table-responsive"></div>';
        jQuery(this).wrap(tableResponsiveContainer);
      });
    }
  }
};
var customProductQuantity = function customProductQuantity() {
  if (jQuery(".single-product").length) {
    if (jQuery(".quantity").length) {
      var $quantityMinus = '<button type="button" class="quantity-button quantity-minus"><span>-</span></button>',
        $quantityPlus = '<button type="button" class="quantity-button quantity-plus"><span>+</span></button>',
        $qty = jQuery(".qty");
      jQuery($quantityMinus).insertBefore($qty);
      jQuery($quantityPlus).insertAfter($qty);
    }
    jQuery(document).on("click", ".quantity-button", function (event) {
      var $qty = jQuery(this).parent(".quantity").find(".qty"),
        $val = parseInt($qty.val());
      if (jQuery(this).hasClass("quantity-minus")) {
        if ($val > 1) {
          $qty.val($val - 1).change();
        }
      } else {
        $qty.val($val + 1).change();
      }
      event.preventDefault();
    });
  }
};

// SOCIAL SHARE LINKS
var socialShareLinks = function socialShareLinks() {
  jQuery(document).on("click", ".block-share__item:not(.block-share__item--download) a", function (event) {
    window.open(this.href, "share_win", "status=1, width=580, height=400, top=" + (jQuery(window).height() - 400) / 2 + ",left=" + (jQuery(window).width() - 580) / 2 + ",scrollbars=no");
    event.preventDefault();
  });
  jQuery(document).on("click", ".entry-share__item--facebook a, .entry-share__item--twitter a, .entry-share__item--linkedin a", function (event) {
    window.open(this.href, "share_win", "status=1, width=580, height=400, top=" + (jQuery(window).height() - 400) / 2 + ",left=" + (jQuery(window).width() - 580) / 2 + ",scrollbars=no");
    event.preventDefault();
  });
  jQuery(document).on("click", ".entry-share__item-toggle a", function (event) {
    jQuery(jQuery(this).attr("href")).slideToggle();
    event.preventDefault();
  });
};

// SKIN FORM EVENT
var formEventSkin = function formEventSkin() {
  if (jQuery(".gfield_placeholder").length) {
    jQuery(".gfield_placeholder").find("input, textarea").each(function (index, elem) {
      var eId = jQuery(elem).attr("id"),
        label = null;
      if (eId && (label = jQuery(elem).parents("form").find("label[for=" + eId + "]")).length == 1) {
        jQuery(elem).attr("placeholder", jQuery(label).text());
      }
    });
  }
};

// FOOTNOTES - READ MORE
var blockReadMore = function blockReadMore() {
  if (jQuery(".entry-footer--expandable").length) {
    jQuery(".entry-footer--expandable").each(function () {
      jQuery(this).readmore({
        collapsedHeight: 145,
        moreLink: '<button type="button" class="bt-see-more bt-see-more--show"><span>Voir plus</span><svg width="10" height="6" aria-hidden="true"><use xlink:href="#bt-toggle" /></svg></button>',
        lessLink: '<button type="button" class="bt-see-more bt-see-more--hide"><span>Replier</span><svg width="10" height="6" aria-hidden="true"><use xlink:href="#bt-toggle" /></svg></button>'
      });
    });
  }
  if (jQuery(".entry-footer--summary-expandable").length) {
    if (jQuery(".entry-footer--summary-expandable").find("li").length > 5) {
      var $footerSummaryDefaultHeight = jQuery(".entry-footer--summary").find("li").outerHeight() * 5 + jQuery(".entry-footer--summary h2").outerHeight() + 12;
      jQuery(".entry-footer--summary").readmore({
        collapsedHeight: $footerSummaryDefaultHeight,
        moreLink: '<button type="button" class="bt-see-more bt-see-more--show bt-see-more-summary--show"><span>Voir plus</span><svg width="10" height="6" aria-hidden="true"><use xlink:href="#bt-toggle" /></svg></button>',
        lessLink: '<button type="button" class="bt-see-more bt-see-more--hide bt-see-more-summary--hide"><span>Replier</span><svg width="10" height="6" aria-hidden="true"><use xlink:href="#bt-toggle" /></svg></button>'
      });
    }
  }
  if (jQuery(".entry-footer-more").length) {
    if (jQuery(".entry-footer--publications").find(".col_publication_item").length > 3) {
      var $footerPublicationsDefaultHeight = 0;
      jQuery(".entry-footer--publications").find(".col_publication_item").each(function () {
        $footerPublicationsDefaultHeight = Math.max(jQuery(this).outerHeight(), $footerPublicationsDefaultHeight);
      });
      if (!window.matchMedia("(max-width: 767px)").matches) {
        $footerPublicationsDefaultHeight = $footerPublicationsDefaultHeight + jQuery(".entry-footer--publications h2").outerHeight() + parseInt(jQuery(".entry-footer--publications").css("padding-top")) + parseInt(jQuery(".entry-footer--publications").css("padding-bottom"));
      } else {
        $footerPublicationsDefaultHeight = jQuery(".entry-footer--publications").find(".col_publication_item").eq(0).outerHeight() + jQuery(".entry-footer--publications").find(".col_publication_item").eq(1).outerHeight() + jQuery(".entry-footer--publications").find(".col_publication_item").eq(2).outerHeight() + jQuery(".entry-footer--publications h2").outerHeight() + parseInt(jQuery(".entry-block").css("padding-bottom")) + 48;
      }
      jQuery(".entry-footer--publications").readmore({
        collapsedHeight: $footerPublicationsDefaultHeight,
        moreLink: '<button type="button" class="bt-see-more bt-see-more--show"><span>Voir plus</span><svg width="10" height="6" aria-hidden="true"><use xlink:href="#bt-toggle" /></svg></button>',
        lessLink: '<button type="button" class="bt-see-more bt-see-more--hide"><span>Replier</span><svg width="10" height="6" aria-hidden="true"><use xlink:href="#bt-toggle" /></svg></button>'
      });
    }
  }
  if (jQuery(".entry-footer--webconferences").length) {
    if (jQuery(".entry-footer--webconferences").find(".col_publication_item").length > 6) {
      var $footerPublicationsDefaultHeight = 0;
      jQuery(".entry-footer--webconferences").find(".col_publication_item").each(function () {
        $footerPublicationsDefaultHeight = Math.max(jQuery(this).outerHeight(), $footerPublicationsDefaultHeight) - 24;
      });
      if (!window.matchMedia("(max-width: 767px)").matches) {
        $footerPublicationsDefaultHeight = $footerPublicationsDefaultHeight + $footerPublicationsDefaultHeight + jQuery(".entry-footer--webconferences h2").outerHeight() + parseInt(jQuery(".entry-footer--webconferences").css("padding-top")) + parseInt(jQuery(".entry-footer--webconferences").css("padding-bottom")) + 16;
      } else {
        jQuery(".entry-footer--webconferences").find(".col_publication_item").each(function () {
          $footerPublicationsDefaultHeight = $footerPublicationsDefaultHeight + jQuery(this).outerHeight();
        });
        $footerPublicationsDefaultHeight = $footerPublicationsDefaultHeight + jQuery(".entry-footer--webconferences h2").outerHeight() + parseInt(jQuery(".entry-block").css("padding-bottom")) + 48;
      }
      jQuery(".entry-footer--webconferences").readmore({
        collapsedHeight: $footerPublicationsDefaultHeight,
        moreLink: '<button type="button" class="bt-see-more bt-see-more--show"><span>Voir plus</span><svg width="10" height="6" aria-hidden="true"><use xlink:href="#bt-toggle" /></svg></button>',
        lessLink: '<button type="button" class="bt-see-more bt-see-more--hide"><span>Replier</span><svg width="10" height="6" aria-hidden="true"><use xlink:href="#bt-toggle" /></svg></button>'
      });
    }
  }
  if (jQuery(".search-block__intro").length) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      jQuery(".search-block__intro").readmore({
        collapsedHeight: 78,
        moreLink: '<button type="button" class="bt-read-all bt-read-all--show"><u>Lire tout</u></button>',
        lessLink: '<button type="button" class="bt-read-all bt-read-all--hide"><u>Replier</u></button>'
      });
    }
  }
};

// TOGGLE SUMMARY

var toggleSummary = function toggleSummary() {
  jQuery(document).on("click", ".bt-toggle", function (event) {
    jQuery(".summary__header").slideToggle();
    jQuery(this).toggleClass("active");
    event.preventDefault();
  });
};

// RESOURCES SLIDER
var swiperResourceSlider,
  $resourceSlider = jQuery(".resources-slider"),
  $slideCount = "",
  $currentSlide = 0,
  resourceSlider = function resourceSlider() {
    if ($resourceSlider.length) {
      if (!window.matchMedia("(max-width: 767px)").matches) {
        $slideCount = 3;
        if ($resourceSlider.find(".swiper-slide").length > $slideCount) {
          swiperResourceSlider = new Swiper(".resources-slider .swiper-container", {
            speed: 800,
            loop: false,
            slidesPerView: $slideCount,
            slidesPerGroup: $slideCount,
            spaceBetween: 20,
            grabCursor: true,
            a11y: true,
            prevSlideMessage: "Ressource précédente",
            nextSlideMessage: "Ressource suivante",
            navigation: {
              nextEl: ".resources-slider .swiper-button-next",
              prevEl: ".resources-slider .swiper-button-prev"
            }
          });
          $resourceSlider.find(".swiper-button").css("top", jQuery(".resource__item__header").height() / 2);
          $resourceSlider.find(".swiper-navigation, .swiper-button").css("display", "block");
        } else {
          if (swiperResourceSlider != undefined) {
            swiperResourceSlider.detachEvents();
            swiperResourceSlider.destroy();
            swiperResourceSlider = undefined;
            $resourceSlider.find(".swiper-wrapper, .swiper-slide").removeAttr("style");
            $resourceSlider.find(".swiper-navigation").css("opacity", 0);
          }
        }
      } else {
        $slideCount = 1;
        if ($resourceSlider.find(".swiper-slide").length > $slideCount) {
          swiperResourceSlider = new Swiper(".resources-slider .swiper-container", {
            speed: 800,
            loop: false,
            slidesPerView: $slideCount,
            slidesPerGroup: $slideCount,
            spaceBetween: 0,
            grabCursor: true,
            a11y: true,
            prevSlideMessage: "Ressource précédente",
            nextSlideMessage: "Ressource suivante",
            navigation: {
              nextEl: ".resources-slider .swiper-button-next",
              prevEl: ".resources-slider .swiper-button-prev"
            }
          });
          $resourceSlider.find(".swiper-button").css("top", jQuery(".resource__item__header").height() / 2);
          $resourceSlider.find(".swiper-navigation, .swiper-button").css("display", "block");
        } else {
          if (swiperResourceSlider != undefined) {
            swiperResourceSlider.detachEvents();
            swiperResourceSlider.destroy();
            swiperResourceSlider = undefined;
            $resourceSlider.find(".swiper-wrapper, .swiper-slide").removeAttr("style");
            $resourceSlider.find(".swiper-navigation").css("opacity", 0);
          }
        }
      }
      $resourceSlider.find(".swiper-wrapper").removeAttr("style").css("opacity", 1);
    }
  };

// TOASTER
var _throttleTimer = null,
  _throttleDelay = 150,
  $toasterBlock = jQuery(".toaster"),
  $window = jQuery(window),
  $document = jQuery(document);
function newsletterToaster(e) {
  if ($toasterBlock.length) {
    if (!_throttleTimer) {
      _throttleTimer = true;
      setTimeout(function () {
        if ($window.scrollTop() + $window.height() >= $document.height()) {
          $toasterBlock.slideDown();
        } else {
          $toasterBlock.slideUp();
        }
        _throttleTimer = false;
      }, _throttleDelay);
    }
  }
  jQuery(document).on("click", ".bt-toaster-close", function (event) {
    event.preventDefault();
    $toasterBlock.fadeOut(function () {
      $toasterBlock.remove();
    });
    Cookies.set("toaster-cookie", "1", {
      expire: 365,
      path: "/"
    });
  });
  if (Cookies.get("toaster-cookie") != null) {
    $toasterBlock.remove();
  }
}

// GALLERY SLIDER
var gallerySlider = function gallerySlider() {
  if (jQuery(".gallery-container").length) {
    jQuery(".gallery-slider").each(function () {
      var $this = jQuery(this),
        $parent = $this.parent();
      if ($this.find(".swiper-slide").length > 1) {
        var swiperGallerySlider = new Swiper($this, {
          speed: 800,
          loop: false,
          // pas de duplication de slides
          slidesPerView: 1,
          navigation: {
            nextEl: $parent.find(".swiper-button-next"),
            prevEl: $parent.find(".swiper-button-prev")
          },
          spaceBetween: 0,
          a11y: true,
          prevSlideMessage: "Précédent",
          nextSlideMessage: "Suivant",
          paginationBulletMessage: "Accéder à l'image {{index}}",
          pagination: {
            el: $parent.find(".swiper-pagination")
          },
          image: {
            tError: "",
            titleSrc: function titleSrc(item) {
              if (item.el.attr("title")) {
                return item.el.attr("title");
              } else {
                return "";
              }
            },
            markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-counter"></div>' + "<figure>" + '<div class="mfp-img"></div>' + "<figcaption>" + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + "</div>" + "</figcaption>" + "</figure>" + "</div>"
          }
        });
      }
    });
    jQuery(".swiper-wrapper").css({
      opacity: 1
    });
  }
};

// GALLERY SWIPER PREV / NEXT
var galleryPrevNextPosition = function galleryPrevNextPosition() {
  if (jQuery(".gallery-container").length) {
    jQuery(".gallery-slider").each(function () {
      var $this = jQuery(this),
        $parent = $this.parent();
      if ($this.find(".swiper-slide").length > 1) {
        $parent.find(".swiper-button-prev").css({
          top: $this.find(".zoom").outerHeight() / 2,
          transform: "translateY(-50%)"
        });
        $parent.find(".swiper-button-next").css({
          top: $this.find(".zoom").outerHeight() / 2,
          transform: "translateY(-50%)"
        });
        $parent.find(".swiper-button-prev, .swiper-button-next, .swiper-pagination").show();
      }
    });
  }
};

// GALLERY LIGHBOX
var galleryLightBox = function galleryLightBox() {
  if (jQuery(".zoom").length) {
    jQuery(".zoom").magnificPopup({
      type: "image",
      tLoading: "Chargement #%curr%...",
      mainClass: "mfp-img-mobile",
      closeOnBgClick: false,
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
        tPrev: "Précédent",
        tNext: "Suivant",
        tCounter: ""
      },
      image: {
        tError: "",
        titleSrc: function titleSrc(item) {
          if (item.el.attr("title")) {
            return item.el.attr("title");
          } else {
            return "";
          }
        },
        markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + "<figure>" + '<div class="mfp-img"></div>' + "<figcaption>" + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + "</div>" + "</figcaption>" + "</figure>" + "</div>"
      }
    });
  }
};

// WARNING ZOOM
var warningZoom = function warningZoom() {
  jQuery(".modal-image").magnificPopup({
    type: "image",
    image: {
      verticalFit: true,
      markup: '<div class="mfp-figure mfp-figure--zoom">' + '<div class="mfp-close"></div>' + "<figure>" + '<div class="mfp-img"></div>' + "</figure>" + "</div>"
    }
  });
};

// PARTNERS SLIDER
var partnerSlider = function partnerSlider() {
  if (jQuery(".block-partners").length) {
    jQuery(".partner-slider").each(function () {
      if (jQuery(this).find(".promotion-slide").length > 4) {
        var $this = jQuery(this),
          $parent = $this.parent();
        var swipePartnerSlider = new Swiper($this, {
          speed: 800,
          loop: true,
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 0,
          paginationClickable: true,
          a11y: true,
          paginationBulletMessage: "Accéder au partenaire {{index}}",
          pagination: {
            el: $parent.find(".swiper-pagination")
          },
          onInit: function onInit() {
            $parent.find(".swiper-pagination").show();
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              slidesPerGroup: 1
            }
          }
        });
      }
    });
    jQuery(".swiper-wrapper").css({
      opacity: 1
    });
  }
  if (window.matchMedia("(min-width: 768px)").matches) {
    if (jQuery(".block-promotion").find(".promotion-slide").length > 4) {
      jQuery(".block-partners").insertAfter(jQuery(".block-promotion").find(".promotion-slide").eq(3));
    }
  }
};

// BACK TO TOP
var backToTop = function backToTop() {
  if (jQuery("#back-to-top").length) {
    var scrollTrigger = 500,
      didScroll = false;
    jQuery.anchorTop = function () {
      var scrollTop = jQuery(window).scrollTop();
      if (scrollTop > scrollTrigger) {
        jQuery("#back-to-top").addClass("show");
      } else {
        jQuery("#back-to-top").removeClass("show");
      }
    };
    jQuery(window).scroll(function () {
      didScroll = true;
    });
    setInterval(function () {
      if (didScroll) {
        didScroll = false;
        jQuery.anchorTop();
      }
    }, 200);
    jQuery("#back-to-top").on("click", function (event) {
      event.preventDefault();
      jQuery("html,body").animate({
        scrollTop: 0
      }, 400);
    });
  }
};

// PAYWALL - ANCHOR
var paywallAnchor = function paywallAnchor() {
  jQuery(document).on("click", ".block-share__item--download a, .entry-download a", function (event) {
    if (jQuery(this).attr("href") == "#paywall") {
      jQuery("#paywall").scrollTo(800);
      event.preventDefault();
    }
  });
};
var archiveFilters = function archiveFilters() {
  var $form = jQuery(".block-form");
  if ($form.length) {
    var filters = i18n.filters[$form.data("post-filter")];
    var rootURI = location.href.split("recherche")[0].replace(/page\/\d*\/?/, "").replace(location.search, "");
    var $sorter = jQuery('[data-sort="tri"]');
    if (!rootURI.match(/\/$/)) {
      rootURI += "/";
    }
    var transform = {
      date: function date(value) {
        var split = value.split("-");
        return [split[2], split[1], split[0]].join("-");
      }
    };
    $form.on("submit", function (e) {
      e.preventDefault();
      var params = "recherche";
      var hasFilter = false;
      for (var filter in filters) {
        var value = jQuery('[data-filter="' + filter + '"]').val();
        if (!value) {
          params += "/-";
          continue;
        }
        params += "/" + encodeURIComponent(transform[filter] ? transform[filter](value) : value);
        hasFilter = true;
      }
      window.location = rootURI + (hasFilter ? params + "/" : "") + ($sorter.length ? "?tri=" + $sorter.val() : "");
    });
  }
};

// FORM - DATE PICKER
function datePicker() {
  if (jQuery("#input-date").length) {
    var picker = new Pikaday({
      field: document.getElementById("input-date"),
      firstDay: 1,
      format: "DD-MM-YYYY",
      minDate: new Date(2010, 1, 1),
      maxDate: new Date(2030, 12, 31),
      yearRange: [new Date().getFullYear(), new Date().getFullYear() + 3],
      i18n: {
        previousMonth: "Mois précédent",
        nextMonth: "Mois suivant",
        months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
        weekdays: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
        weekdaysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]
      }
    });
  }
}

// RESPONSIVE SIDEBAR - DETACH SIDEBAR ON MOBILE
var responsiveSidebar = function responsiveSidebar() {
  if (jQuery(".col-header__sidebar").length) {
    if (window.matchMedia("(min-width: 992px)").matches) {
      if (!jQuery(".row--header").find(".col-header__sidebar").length) {
        jQuery(".col-header__sidebar").insertAfter(jQuery(".col-header__content"));
      }
    } else {
      if (jQuery(".row--header").find(".col-header__sidebar").length) {
        jQuery(".col-header__sidebar").insertAfter(jQuery(".row--main"));
      }
    }
  }
};

// CUSTOM MODAL
var customModal = function customModal() {
  if (jQuery("#modal-custom").length) {
    jQuery.magnificPopup.open({
      items: {
        src: "#modal-custom"
      },
      type: "inline",
      preloader: false,
      modal: true
    });
  }
  if (jQuery(".open-classified-contact-form").length) {
    jQuery(".open-classified-contact-form").magnificPopup({
      type: "inline"
    });
  }
  if (jQuery(".promotion--single .promotion__gallery").length) {
    jQuery(".promotion--single .promotion__gallery.mnfp").magnificPopup({
      delegate: "img",
      type: "image",
      gallery: {
        enabled: true
      }
    });
  }
};

// LOAD "rubrique" CONTENT DYNAMICALLY
var shopCategory = function shopCategory() {
  var $categories = jQuery('[name="select-category"]');
  if ($categories.length && jQuery(document.body).hasClass("post-type-archive-product")) {
    var $heading = jQuery('[name="select-heading"]');
    $categories.on("change", function () {
      jQuery.get(i18n.ajaxurl, {
        action: "get_headings_by_category",
        category: $categories.val()
      }, function (response) {
        if (!response.data) {
          return;
        }
        var content = '<option value="">Rubrique</option>';
        response.data.forEach(function (item) {
          content += '<option value="' + item.slug + '">' + item.name + "</li>";
        });
        $heading.html(content);
      });
    });
  }
};

// PROGRAM

var updateProgramPosition = function updateProgramPosition() {
  if (jQuery("#block-program").length) {
    if (jQuery("#program").length) {
      jQuery("#block-program").insertAfter(jQuery("#program"));
    }
    if (jQuery(".block-subscription").length) {
      jQuery(".block-subscription").clone().insertAfter(jQuery("#block-program"));
    }
  }
};

// CALENDAR HP
var calendarHomePage = function calendarHomePage() {
  if (jQuery("#input-calendar").length) {
    var picker = new Pikaday({
      field: document.getElementById("input-calendar"),
      firstDay: 1,
      format: "DD-MM-YYYY",
      minDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDay()),
      maxDate: new Date(new Date().getFullYear() + 1, new Date().getMonth() + 1, new Date().getDay()),
      bound: false,
      container: document.getElementById("event-calendar"),
      onSelect: function onSelect(date) {
        document.location.href = "/agenda/recherche/-/-/" + jQuery(".is-selected .pika-day").data("pika-year") + "-" + parseInt(jQuery(".is-selected .pika-day").data("pika-month") + 1) + "-" + jQuery(".is-selected .pika-day").data("pika-day") + "/-/-/";
      },
      i18n: {
        previousMonth: "Mois précédent",
        nextMonth: "Mois suivant",
        months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
        weekdays: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
        weekdaysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]
      }
    });
  }
};

// TOASTER
var $toasterHelper = jQuery("#toaster-helper"),
  $backToTop = jQuery("#back-to-top"),
  helperToasterClose = function helperToasterClose() {
    if ($backToTop.length && $toasterHelper.length) {
      $backToTop.addClass("hidden");
    }
    jQuery(document).on("click", ".bt-toaster-close", function (event) {
      $toasterHelper.toggleClass("hidden");
      $backToTop.toggleClass("hidden");
      event.preventDefault();
    });
  };

// ANCHOR COMMENTS
var anchorComments = function anchorComments() {
  var $anchor_comment = jQuery("#anchor-comments"),
    $paywall = jQuery("#paywall");
  jQuery(document).on("click", ".entry-share__item--comments a", function (event) {
    if ($anchor_comment.length) {
      $anchor_comment.scrollTo(800);
    } else {
      if ($paywall.length) {
        $paywall.scrollTo(800);
      }
    }
    event.preventDefault();
  });
};

// WEBINAR COUNT DOWN
var countDown = function countDown() {
  var $count_down = jQuery("#count-down"),
    $days = "",
    $hours = "",
    $minutes = "";
  if ($count_down.length && $count_down.data("webinar-date").length) {
    $count_down.countdown($count_down.data("webinar-date"), function (event) {
      if (event.offset.totalDays != 0) {
        $days = '<div class="item-countdown">%-D jour%!D,</div>';
      }
      if (event.offset.totalHours != 0) {
        $hours = '<div class="item-countdown">%-H heure%!H,</div>';
      }
      if (event.offset.minutes != 0) {
        $minutes = '<div class="item-countdown">%-M minute%!M</div>';
      }
      var $this = jQuery(this).html(event.strftime("" + $days + $hours + $minutes));
    });
  }
};

// TOOLTIP
var tooltipInfos = function tooltipInfos() {
  var $rpps = jQuery("#reg_profile_rpps"),
    $input_information = jQuery(".input-information"),
    $rpps_tooltip = jQuery(".rpps__tooltip");
  if ($rpps.length && $rpps_tooltip.length) {
    $rpps.addClass("tooltip").tooltipster({
      content: $rpps_tooltip.html(),
      contentAsHTML: true,
      interactive: true,
      maxWidth: "250"
    });
  }
  if ($input_information && $rpps_tooltip.length) {
    $input_information.addClass("tooltip").tooltipster({
      content: $rpps_tooltip.html(),
      contentAsHTML: true,
      interactive: true,
      maxWidth: "250"
    });
  }
};

// SPECIMEN FORM
var toggleSpecimenForm = function toggleSpecimenForm() {
  if (jQuery("#specimen_order").length) {
    if (jQuery("#specimen_order").is(":checked")) {
      jQuery(".partner_form").slideDown();
    }
  }
  jQuery(document).on("click", "#specimen_order", function () {
    if (jQuery(this).is(":checked")) {
      jQuery(".partner_form").slideDown();
    } else {
      jQuery(".partner_form").slideUp();
    }
  });
};

// HIGHLIGHT SIDEBAR WEBINAR
var highlightSidebarWebinar = function highlightSidebarWebinar() {
  var $sidebar_webinar = jQuery(".sidebar-block--webinar");
  jQuery(document).on("click", ".bt-highlight-subscription", function (event) {
    $sidebar_webinar.addClass("active");
    $sidebar_webinar.scrollTo(800);
    event.preventDefault();
  });
};

// SIDEBAR - DOWNLOAD ARTICLE
var anchorDownloadArticle = function anchorDownloadArticle(event) {
  var $paywall = "#paywall";
  jQuery(document).on("click", ".bt-dld", function (event) {
    if (jQuery(this).attr("href") == $paywall) {
      jQuery($paywall).scrollTo(800);
      event.preventDefault();
    }
  });
};

// COMMENT - REACT ANCHOR
var anchorToReactComment = function anchorToReactComment(event) {
  var $comment = jQuery("#comment"),
    $respond = jQuery("#respond"),
    $comments = jQuery("#comments"),
    $must_login = jQuery(".entry-comments .must-log-in"),
    $share_comments = jQuery(".entry-share__item--comments");
  if ($respond.length) {
    $comments.show();
    if ($share_comments.length) {
      $share_comments.show();
    }
    if ($must_login.length) {
      $respond.show();
    }
    jQuery(document).on("click", ".bt-comment, .comment-reply-link", function (event) {
      $respond.show();
      $comment.scrollTo(800);
      $comment.focus();
      event.preventDefault();
    });
  }
};

// PAYWALL FORM SKIN
var payWallFormSkin = function payWallFormSkin() {
  if (jQuery(".subscription-block").length) {
    if (jQuery(".login-submit").length && jQuery(".block-lost-pwd").length) {
      jQuery(".block-lost-pwd").prependTo(jQuery(".login-submit"));
    }
  }
  jQuery(document).on("click", ".subscription-block__item--buy-article img", function () {
    jQuery(this).parents(".subscription-block__item--buy-article").find("button").trigger("click");
  });
  jQuery(document).on("click", ".subscription-block__item--buy-issue img", function () {
    document.location.href = jQuery(this).parents(".bt-buying").find("a").attr("href");
  });
};

// PETITES ANNONCES - DETAILS
var classifiedDetails = function classifiedDetails() {
  var $classifiedNav = jQuery(".classified-nav");
  if ($classifiedNav.length) {
    $classifiedNav.appendTo(jQuery(".header"));
  }
  jQuery(document).on("click", ".bt-details", function (event) {
    jQuery(this).parents(".grid-item").toggleClass("active");
    if (jQuery(this).parents(".grid-item").hasClass("active")) {
      jQuery(this).find("strong").html("Cacher le détail");
    } else {
      jQuery(this).find("strong").html("Voir le détail");
    }
    event.preventDefault();
  });
  jQuery(document).on("click", ".bt-show-col", function (event) {
    var _this = jQuery(this),
      $hide_row_mobile = jQuery(".hide-row-mobile"),
      $show = _this.data("show"),
      $hide = _this.data("hide");
    _this.parents(".pa-table-container").find("." + $hide).removeClass("col-show").addClass("col-hide");
    _this.parents(".pa-table-container").find("." + $show).removeClass("col-hide").addClass("col-show");
    $show == "col-3" ? $hide_row_mobile.hide() : $hide_row_mobile.show();
    _this.parents(".table-tabs").find("button").removeClass("active");
    _this.addClass("active");
    event.preventDefault();
  });
};

// CURRENTLY SLIDER
var swiperCurrentlySlider = undefined,
  $currentlySlider = jQuery(".header-currently__slider"),
  currentlySlider = function currentlySlider() {
    if ($currentlySlider.length) {
      if (!jQuery(".home").length) {
        if (!jQuery(".header-currently__title").find("a").length) {
          jQuery(".header-currently__title").find("div").html(jQuery(".header-currently__list").find(".swiper-slide:first").html());
          jQuery(".header-currently__list").find(".swiper-slide:first").remove();
        }
      }
      swiperCurrentlySlider = new Swiper(".header-currently__slider", {
        speed: 800,
        loop: false,
        slidesPerView: "auto",
        a11y: true
      });
      $currentlySlider.find(".swiper-wrapper").css("opacity", "1");
    }
  };

// UNIVERSE SLIDER
var swiperUniverseSlider = undefined,
  $universeSlider = jQuery(".header-universe__slider"),
  universeSlider = function universeSlider() {
    if ($universeSlider.length) {
      if (jQuery(".header-universe__slider").width() == jQuery(".header-universe__inner").width()) {
        swiperUniverseSlider = new Swiper(".header-universe__slider", {
          speed: 800,
          loop: false,
          slidesPerView: "auto",
          a11y: true
        });
      }
      $universeSlider.find(".swiper-wrapper").css("opacity", "1");
    }
  };

// VIDEOLIGHBOX
var videoLightBox = function videoLightBox() {
  jQuery(".popup-video").magnificPopup({
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
};

// PODCAST SLIDER
var swiperPodcastSlider,
  $podcastSlider = jQuery(".podcast-slider"),
  $slideCount = "",
  $currentSlide = 0,
  podcastSlider = function podcastSlider() {
    if ($podcastSlider.length) {
      if ($podcastSlider.find(".swiper-slide").length > 1) {
        swiperPodcastSlider = new Swiper(".podcast-slider .swiper-container", {
          speed: 800,
          loop: false,
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          grabCursor: true,
          a11y: true,
          prevSlideMessage: "Podcast précédent",
          nextSlideMessage: "Podcast suivant",
          navigation: {
            nextEl: ".podcast-slider .swiper-button-next",
            prevEl: ".podcast-slider .swiper-button-prev"
          }
        });
        $podcastSlider.find(".swiper-navigation, .swiper-button").css("display", "block");
      } else {
        if (swiperPodcastSlider != undefined) {
          swiperPodcastSlider.detachEvents();
          swiperPodcastSlider.destroy();
          swiperPodcastSlider = undefined;
          $podcastSlider.find(".swiper-wrapper, .swiper-slide").removeAttr("style");
          $podcastSlider.find(".swiper-navigation").css("opacity", 0);
        }
      }
      $podcastSlider.find(".swiper-wrapper").removeAttr("style").css("opacity", 1);
    }
  };

// INFOGRAPHIC SLIDER
/*
var swiperInfographicSlider,
	$infographicSlider = jQuery('.infographic-slider'),
	infographicSlider = function () {
		if ($infographicSlider.length) {
			if ($infographicSlider.find('.swiper-slide').length > 1) {
				swiperInfographicSlider = new Swiper('.infographic-slider .swiper-container', {
					speed: 800,
					loop: false,
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 0,
					grabCursor: true,
					a11y: true,
					prevSlideMessage: 'Infographie précédente',
					nextSlideMessage: 'Infographie suivante',
					navigation: {
						nextEl: '.infographic-slider .swiper-button-next',
						prevEl: '.infographic-slider .swiper-button-prev',
					}
				});
				$infographicSlider.find('.swiper-navigation, .swiper-button').css('display', 'block');
			} else {
				if (swiperInfographicSlider != undefined) {
					swiperInfographicSlider.detachEvents();
					swiperInfographicSlider.destroy();
					swiperInfographicSlider = undefined;
					$infographicSlider.find('.swiper-wrapper, .swiper-slide').removeAttr('style');
					$infographicSlider.find('.swiper-navigation').css('opacity', 0);
				}
			}
			$infographicSlider.find('.swiper-wrapper')
				.removeAttr('style')
				.css('opacity', 1);
		}
};
*/

var swiperInfographicSlider,
  $infographicSlider = jQuery(".infographic-slider"),
  infographicSlider = function infographicSlider() {
    if ($infographicSlider.length) {
      $infographicSlider.each(function () {
        if (jQuery(this).find(".swiper-slide").length > 1) {
          var $this = jQuery(this);
          swiperInfographicSlider = new Swiper($this.find(".swiper-container"), {
            speed: 800,
            loop: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            grabCursor: true,
            a11y: true,
            prevSlideMessage: "Infographie précédente",
            nextSlideMessage: "Infographie suivante",
            navigation: {
              nextEl: $this.find(".swiper-button-next"),
              prevEl: $this.find(".swiper-button-prev")
            }
          });
          $this.find(".swiper-navigation, .swiper-button").css("display", "block");
        }
        jQuery(this).find(".swiper-wrapper").css("opacity", 1);
      });
    }
  };

// JIP

var changeInputStatus = function changeInputStatus() {
  jQuery(document).on("click", ".bt-change-status", function (event) {
    jQuery("#email").removeAttr("disabled").removeClass("input-disabled").focus();
    event.preventDefault();
  });
};

// LOGOS SLIDER
var logosSlider = function logosSlider() {
  if (jQuery(".logos__slider").length) {
    jQuery(".logos__slider").each(function () {
      if (jQuery(this).find(".swiper-slide").length > 1) {
        var $this = jQuery(this);
        var swipeLogosSlider = new Swiper($this, {
          effect: "fade",
          speed: 800,
          loop: true,
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          a11y: true,
          autoplay: {
            delay: 2500
          }
          // Pagination section is commented out to remove bullets
          // pagination: {
          //     el: $this.find(".swiper-pagination"),
          //     clickable: true,
          // },
        });
      }

      jQuery(this).find(".swiper-wrapper").css("opacity", 1);
      jQuery(this).find(".swiper-pagination").hide();
    });
  }
};

// LOGOS SLIDER
var publicationSlider = function publicationSlider() {
  if (jQuery(".publication-slider").length) {
    jQuery(".publication-slider").each(function () {
      if (jQuery(this).find(".swiper-slide").length > 1) {
        var _Swiper;
        var $this = jQuery(this);
        var $parent = $this.parent();
        var swiperPushSlider = new Swiper($this, (_Swiper = {
          speed: 800,
          loop: true,
          slidesPerView: 2,
          paginationClickable: true,
          navigation: {
            nextEl: $parent.find(".swiper-button-next"),
            prevEl: $parent.find(".swiper-button-prev")
          },
          spaceBetween: 10,
          a11y: true,
          prevSlideMessage: "Précédent",
          nextSlideMessage: "Suivant",
          paginationBulletMessage: "Accéder à l'image {{index}}"
        }, _defineProperty(_Swiper, "paginationClickable", true), _defineProperty(_Swiper, "pagination", {
          el: $parent.find(".swiper-pagination")
        }), _defineProperty(_Swiper, "onInit", function onInit() {
          $parent.find(".swiper-button-prev, .swiper-button-next, .swiper-pagination").show();
        }), _defineProperty(_Swiper, "breakpoints", {
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        }), _Swiper));
      }
      jQuery(this).find(".swiper-wrapper").css("opacity", 1);
      jQuery(this).find(".swiper-pagination").show();
    });
  }
};

// DOCUMENT READY
jQuery(document).ready(function () {
  removeAutoCheckInFormBlock();
  styleFocusOnKeyboardEvents();
  promotionSlider();
  tableResponsive();
  customProductQuantity();
  mainNavSticky();
  socialShareLinks();
  formEventSkin();
  gallerySlider();
  partnerSlider();
  galleryLightBox();
  backToTop();
  paywallAnchor();
  archiveFilters();
  datePicker();
  responsiveSidebar();
  shopCategory();
  warningZoom();
  $window.on("scroll", newsletterToaster);
  updateProgramPosition();
  calendarHomePage();
  helperToasterClose();
  anchorComments();
  countDown();
  toggleSpecimenForm();
  highlightSidebarWebinar();
  anchorDownloadArticle();
  anchorToReactComment();
  tooltipInfos();
  payWallFormSkin();
  resourceSlider();
  toggleSummary();
  classifiedDetails();
  currentlySlider();
  universeSlider();
  videoLightBox();
  podcastSlider();
  infographicSlider();
  changeInputStatus();
  logosSlider();
  publicationSlider();
});
jQuery(window).on("load", function () {
  jQuery("body").addClass("loaded");
  responsiveNav();
  customModal();
  galleryPrevNextPosition();
  setTimeout(blockReadMore(), 100);
  showHideSearch();
  select2(jQuery);

  // Log

  jQuery(".id-select2").select2({
    language: "fr"
  });
  jQuery(".id-select2-2").select2({
    language: "fr",
    theme: "custom-id"
  });
  jQuery(".id-select2-ajax").select2({
    language: "fr",
    ajax: {
      url: window.i18n.ajaxurl,
      data: function data(params) {
        return {
          s: params.term,
          restrict: 1,
          action: "search_cities_zipcode"
        };
      },
      processResults: function processResults(data) {
        var _this2 = this;
        var _data = data.cities.map(function (c) {
          _newArrowCheck(this, _this2);
          return {
            id: c.insee,
            text: c.name
          };
        }.bind(this));
        return {
          results: _data
        };
      }
    }
  });
});
jQuery(window).on("resize", function () {
  galleryPrevNextPosition();
  promotionSlider();
  responsiveSidebar();
  resourceSlider();
  currentlySlider();
  universeSlider();
  podcastSlider();
  infographicSlider();
  if (!window.matchMedia("(min-width: 992px)").matches) {
    if (!jQuery(".header-top").find(".mobile-container").length) {
      jQuery(".mobile-container").appendTo(jQuery(".header-top"));
    }
  }
});
if (jQuery(".gallery-slider").length) {
  jQuery(".gallery-slider").each(function () {
    var $this = jQuery(this),
      $parent = $this.parent();
    if ($this.find(".swiper-slide").length > 1) {
      var _Swiper2;
      var swiperPushSlider = new Swiper($this, (_Swiper2 = {
        speed: 800,
        loop: false,
        slidesPerView: 1,
        paginationClickable: true,
        navigation: {
          nextEl: $parent.find(".swiper-button-next"),
          prevEl: $parent.find(".swiper-button-prev")
        },
        spaceBetween: 0,
        a11y: true,
        prevSlideMessage: "Précédent",
        nextSlideMessage: "Suivant",
        paginationBulletMessage: "Accéder à l'image {{index}}"
      }, _defineProperty(_Swiper2, "paginationClickable", true), _defineProperty(_Swiper2, "pagination", {
        el: $parent.find(".swiper-pagination"),
        clickable: true
      }), _defineProperty(_Swiper2, "onInit", function onInit() {
        $parent.find(".swiper-button-prev, .swiper-button-next, .swiper-pagination").show();
      }), _Swiper2));
    }
  });
  jQuery(".swiper-wrapper").css({
    opacity: 1
  });
}
jQuery(".text-expandable .expander").on("click", function (e) {
  e.preventDefault();
  var $parent = jQuery(this).parent();
  console.log("parent", $parent);
  $parent.toggleClass("show");
});
jQuery(".js-more").on("click", function (e) {
  e.preventDefault();
  jQuery(this).toggleClass("active");
});
jQuery(".js-dropdown").on("click", function (e) {
  e.preventDefault();
  var _target = jQuery(this).data("target");
  jQuery(_target).toggleClass("open");
  var _label;
  if (jQuery(_target).hasClass("open")) {
    jQuery(this).addClass("active");
    jQuery(this).find("span").text(jQuery(this).data("label-open"));
  } else {
    jQuery(this).removeClass("active");
    jQuery(this).find("span").text(jQuery(this).data("label"));
  }
});
jQuery(".card-classified-cat").on("click", function () {
  var _this = jQuery(this);
  if (_this.hasClass("active")) {
    _this.removeClass("active");
  } else {
    jQuery(".card-classified-cat.active").removeClass("active");
    _this.addClass("active");
  }
});
jQuery(".promotion__meta .cities .content").each(function () {
  jQuery(this).readmore({
    collapsedHeight: 17,
    moreLink: '<span class="readmore"><svg width="16" height="16" fill="currentColor" class="bi bi-chevron-down expand-icon" viewBox="0 0 16 16" id="expandIcon"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></svg></span>',
    lessLink: '<span class="readless"><svg width="16" height="16" fill="currentColor" class="bi bi-chevron-down expand-icon" viewBox="0 0 16 16" id="expandIcon"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></svg></span>'
  });
});